import React from 'react';
import { Typography } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';
import AuditHistoryTable from '../AuditHistoryTable';
import { Location } from '../../types';

const { Title } = Typography;

interface AuditHistoryTabProps {
  assetId: number;
  locations: Location[];
}

const AuditHistoryTab: React.FC<AuditHistoryTabProps> = ({ assetId, locations }) => {
  return (
    <div style={{ padding: 24 }}>
      <Title level={5} style={{ marginBottom: 16, textTransform: 'uppercase' }}>
        <ClockCircleOutlined style={{ marginRight: 8 }} />
        Lịch sử kiểm kê
      </Title>
      <AuditHistoryTable assetId={assetId} locations={locations} />
    </div>
  );
};

export default AuditHistoryTab; 